// extracted by mini-css-extract-plugin
export default {"files_rows":"index_files_rows__7VJqU","group_header":"index_group_header__vZEbL","flies_group":"index_flies_group__b84b6","subcategory_header":"index_subcategory_header__ZkmgE"};